import { SoldoutProductStory } from '@aclass/admin/storage/actions';
import { INITIAL_SOLDOUT_PRODUCT_STATE, ISoldoutProductModuleState } from '@aclass/admin/storage/states';
import { Action } from '@aclass/core/storage/action';
import { TypedState } from '@aclass/core/storage/states/module.state';
import { fromJS, List, Map } from 'immutable';

export const soldoutProductModuleReducer =
    (state: TypedState<ISoldoutProductModuleState> = INITIAL_SOLDOUT_PRODUCT_STATE, action: Action) => {
    const { type, payload } = action;
    switch (type) {
        case SoldoutProductStory.SEARCH_PAGE_UPDATE_INIT_STATE:
            return state.update('searchPageInitialized', () => payload);
        case SoldoutProductStory.SEARCH_PAGE_UPDATE_COLLAPSED:
            return state.update('searchPageCollapsed', () => payload);
        case SoldoutProductStory.SEARCH_PAGE_UPDATE_FORM:
            return state.update('searchPageForm', () => fromJS(payload));
        case SoldoutProductStory.SEARCH_PAGE_UPDATE_SEARCH_LOCK:
            return state.update('searchPageLock', () => payload);
        case SoldoutProductStory.SEARCH_PAGE_UPDATE_PAGINATION:
            return state.update('searchPagePagination', () => Map(payload));
        case SoldoutProductStory.SEARCH_PAGE_UPDATE_ORDER:
            return state.update('searchPageOrder', () => Map(payload));
        case SoldoutProductStory.SEARCH_PAGE_IMPORT_RECORDS:
            return state.update('searchPageResults', () => List(payload));
        case SoldoutProductStory.IMPORT_HOTELS_RECORDS:
            return state.update('createUpdateProducts', () => List(payload));
        case SoldoutProductStory.PRODUCT_UPDATE_OPTIONS:
            return state.update('productOptions', () => List(payload));
        case SoldoutProductStory.PRODUCT_ID_UPDATE_OPTIONS_IDS:
            return state.updateIn(['productOptionsIdsByProductId', payload.uid], () => List(payload.ids));
        case SoldoutProductStory.EDIT_PAGE_CREATE_FORM:
            return state.update('createPageForm', () => fromJS(payload));
        case SoldoutProductStory.EDIT_PAGE_UPDATE_SOLDOUT_ID:
            return state.update('editPageRecordId', () => payload);
        case SoldoutProductStory.EDIT_PAGE_UPDATE_FORM:
            return state.update('editPageForm', () => fromJS(payload));
        case SoldoutProductStory.EDIT_PAGE_UPDATE_FORM_PERIOD:
            return state.update('editPageFormPeriod', () => List(payload));
        default:
            return state;
    }
};
